export { UserAvatar } from './src/components/Avatar'
export type { UserAvatarIProps, UserAvatarSize } from './src/components/Avatar'
export { OperatorAvatar, AI_OPERATOR_NAME } from './src/components/Avatar'
export type { OperatorAvatarIProps } from './src/components/Avatar'
export { BadgeCounter } from './src/components/BadgeCounter'
export type {
  BadgeCounterProps,
  BadgeCounterIProps,
  BadgeCounterVariant,
} from './src/components/BadgeCounter'
export {
  Button,
  IconButton,
  AddButton,
  UtilityButton,
  IncidentActionButton,
  UTILITY_BUTTON_SIZE,
  WorkflowButton,
} from './src/components/Button'
export { Pill, FacilityPill, StatusPill } from './src/components/Pill'
export type {
  PillProps,
  FacilityPillProps,
  StatusPillProps,
  StatusPillVariant,
} from './src/components/Pill'
export type {
  ButtonProps,
  ButtonVariant,
  ButtonSize,
  IconButtonProps,
  AddButtonProps,
  UtilityButtonProps,
  IncidentActionButtonProps,
  WorkflowButtonIProps,
} from './src/components/Button'
export {
  ActivityIcon,
  AddIcon,
  ArrowLeftIcon,
  AssociateIncidentIcon,
  CreateIcon,
  EmergencyCallFilledIcon,
  AwardIcon,
  CheckSquareIcon,
  AssociatedDeviceIcon,
  GridEnabledIcon,
  ArrowRightCircleIcon,
  StarIcon,
  DragHandleIcon,
  AlarmIcon,
  CameraIcon,
  ClockIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CopyIcon,
  CloseIcon,
  CredentialsIcon,
  DeleteIcon,
  DeviceStatusIcon,
  DoorIcon,
  UserIcon,
  DownloadIcon,
  EditIcon,
  FilterIcon,
  FloorsIcon,
  CheckpointsIcon,
  GridTestingIcon,
  GuardsIcon,
  KebabHorizontalIcon,
  KebabVerticalIcon,
  InfoIcon,
  HelpIcon,
  KnowledgeBaseIcon,
  LogoutIcon,
  LabelIcon,
  NoteIcon,
  PaperClipIcon,
  VoiceMemoIcon,
  ResolveIcon,
  RemoveIcon,
  ReplySubmitIcon,
  SearchIcon,
  SendIcon,
  SOPIcon,
  WorkflowCheckIcon,
  CheckIcon,
  ThumbsUpIcon,
  ThumbsDownIcon,
  AlertCircleIcon,
  AlertTriangleIcon,
  BellIcon,
  BellOffIcon,
  CheckCircleIcon,
  EyeIcon,
  FileAudioIcon,
  FileIcon,
  FileSpreadsheetIcon,
  FileTextIcon,
  FilmIcon,
  MaximizeIcon,
  MinimizeIcon,
  RefreshIcon,
  ZoomInIcon,
  ZoomOutIcon,
  FlagIcon,
  IncidentPriorityIcon,
  ManualIcon,
  MailIcon,
  MapIcon,
  MapPinIcon,
  MicIcon,
  PauseIcon,
  PictureInPictureIcon,
  PictureInPictureExitIcon,
  PlayIcon,
  RecordIcon,
  PhoneOffIcon,
  QuickReportIcon,
  PhoneOutgoingIcon,
  ReleaseIcon,
  SettingsIcon,
  StopIcon,
  ToolIcon,
  TrashIcon,
  XCircleIcon,
  ShareIcon,
  ShieldIcon,
  AiOperatorIcon,
  CaseManagementIcon,
  DashboardIcon,
  EmergencyCallIcon,
  FacilityIcon,
  GatewayIcon,
  GlobeIcon,
  GuardTourIcon,
  IncidentIcon,
  LockedIcon,
  ProgramRecommendationsIcon,
  RuleIcon,
  SecurityDeviceIcon,
  UnlockedIcon,
  WorkflowIcon,
} from './src/components/Icon'
export { errorColorFor } from './src/components/shared/errorColor'
export type {
  ActivityIconProps,
  ArrowLeftIconProps,
  AssociateIncidentIconProps,
  AwardIconProps,
  AlarmIconProps,
  CameraIconProps,
  ClockIconProps,
  ChevronDownIconProps,
  ChevronLeftIconProps,
  ChevronUpIconProps,
  ChevronRightIconProps,
  CopyIconProps,
  CredentialsIconProps,
  DeviceStatusIconProps,
  InfoIconProps,
  DeviceStatusType,
  DoorIconProps,
  DownloadIconProps,
  UserIconProps,
  FilterIconProps,
  GridTestingIconProps,
  GuardsIconProps,
  KebabHorizontalIconProps,
  KebabVerticalIconProps,
  HelpIconProps,
  KnowledgeBaseIconProps,
  LogoutIconProps,
  LabelIconProps,
  NoteIconProps,
  PaperClipIconProps,
  VoiceMemoIconProps,
  ResolveIconProps,
  SOPIconProps,
  CheckIconProps,
  ThumbsUpIconProps,
  ThumbsDownIconProps,
  AlertCircleIconProps,
  AlertTriangleIconProps,
  BellIconProps,
  BellOffIconProps,
  CheckCircleIconProps,
  EyeIconProps,
  FileAudioIconProps,
  FileIconProps,
  FileSpreadsheetIconProps,
  FileTextIconProps,
  FilmIconProps,
  MaximizeIconProps,
  MinimizeIconProps,
  RefreshIconProps,
  ZoomInIconProps,
  ZoomOutIconProps,
  FlagIconProps,
  IncidentPriorityIconProps,
  ManualIconProps,
  MailIconProps,
  MapIconProps,
  MapPinIconProps,
  MicIconProps,
  PauseIconProps,
  PictureInPictureIconProps,
  PictureInPictureExitIconProps,
  PlayIconProps,
  RecordIconProps,
  PhoneOffIconProps,
  QuickReportIconProps,
  PhoneOutgoingIconProps,
  ReleaseIconProps,
  SendIconProps,
  SettingsIconProps,
  StopIconProps,
  ToolIconProps,
  TrashIconProps,
  XCircleIconProps,
  ShareIconProps,
  ShieldIconProps,
} from './src/components/Icon'
export { MultilineTextInput } from './src/components/MultilineTextInput'
export type { MultilineTextInputProps } from './src/components/MultilineTextInput'
export { MultiSelectInput } from './src/components/MultiSelectInput'
export type {
  MultiSelectInputProps,
  MultiSelectOption,
} from './src/components/MultiSelectInput'
export { TextInput } from './src/components/TextInput'
export type { TextInputProps } from './src/components/TextInput'
export { FieldLabel } from './src/components/FieldLabel'
export type { FieldLabelProps } from './src/components/FieldLabel'
export { NumberInput } from './src/components/NumberInput'
export type { NumberInputProps } from './src/components/NumberInput'
export { Autocomplete } from './src/components/Autocomplete'
export type {
  AutocompleteProps,
  AutocompleteOption,
} from './src/components/Autocomplete'
export { FacilityMapMarker } from './src/components/MapMarker'
export type { FacilityMapMarkerProps } from './src/components/MapMarker'
export { LocationBreadcrumb } from './src/components/LocationBreadcrumb'
export type {
  LocationBreadcrumbProps,
  BreadcrumbItem,
} from './src/components/LocationBreadcrumb'
export {
  DarkProvider,
  SELECTION_BG_VAR,
  SELECTION_FG_VAR,
} from './src/components/Provider'
export type { DarkProviderIProps } from './src/components/Provider'
export { Slider } from './src/components/Slider'
export type { SliderProps } from './src/components/Slider'
export { Toggle } from './src/components/Toggle'
export type { ToggleProps } from './src/components/Toggle'
export { Tabs } from './src/components/Tabs'
export type { TabsProps, TabItem } from './src/components/Tabs'
export { TopBar, TOP_BAR_HEIGHT } from './src/components/TopBar'
export type { TopBarProps, TopBarItem } from './src/components/TopBar'
export { Tag } from './src/components/Tag'
export type { TagProps } from './src/components/Tag'
export { TagGroup } from './src/components/TagGroup'
export type { TagGroupProps } from './src/components/TagGroup'
export {
  TypeaheadSearch,
  BulkTypeaheadSearch,
  checkboxOptionRowStyles,
  checkboxStyles,
  dropdownStyles,
} from './src/components/TypeaheadSearch'
export { useDropdownPosition } from './src/components/TypeaheadSearch/useDropdownPosition'
export type { DropdownPosition } from './src/components/TypeaheadSearch/useDropdownPosition'
export type {
  TypeaheadSearchProps,
  TypeaheadOption,
  PrimaryAction,
  ColorScheme,
  CheckboxOption,
  BulkTypeaheadSearchProps,
} from './src/components/TypeaheadSearch'

export { ActionBar } from './src/components/ActionBar'
export type {
  ActionBarProps,
  ActionBarAction,
} from './src/components/ActionBar'
export { ActionMenu } from './src/components/ActionMenu'
export type {
  ActionMenuProps,
  ActionMenuItem,
} from './src/components/ActionMenu'
export { UserMenu } from './src/components/UserMenu'
export type { UserMenuProps, UserMenuItem } from './src/components/UserMenu'
export {
  USER_MENU_ICON_SIZE,
  USER_MENU_MIN_WIDTH,
  userMenuNameStyles,
  userMenuRoleStyles,
} from './src/components/UserMenu'
export { Popover } from './src/components/Popover'
export type { PopoverProps, PopoverPlacement } from './src/components/Popover'
export { CountToggle } from './src/components/CountToggle'
export type { CountToggleProps } from './src/components/CountToggle'
export { system, config } from './src/theme/system'
export { tokenVar } from './src/theme/tokenVar'
export { tokenPrefix } from './src/theme/tokenPrefix'
export { fontFamilies } from './src/theme/fontFamilies'
export { Modal, Drawer, useOverlayStack } from './src/components/Modal'
export type {
  ModalProps,
  DrawerProps,
  UseOverlayStackProps,
} from './src/components/Modal'
export {
  Card,
  CardHeader,
  CardFooter,
  CardCollapsibleRow,
  CardExpandable,
  expandableWrapperStyles,
} from './src/components/Card'
export type {
  CardProps,
  CardHeaderProps,
  CardFooterProps,
  CardCollapsibleRowProps,
  CardExpandableProps,
} from './src/components/Card'
export { CardGroup } from './src/components/CardGroup'
export type {
  CardGroupOption,
  CardGroupProps,
} from './src/components/CardGroup'
export { FlashCard } from './src/components/Card'
export type { FlashCardProps } from './src/components/Card'
export { SuccessBanner, InfoBanner } from './src/components/Banner'
export type {
  SuccessBannerProps,
  InfoBannerIProps,
  InfoBannerTone,
} from './src/components/Banner'
export { Alert, ALERT_VARIANTS } from './src/components/Alert'
export type {
  AlertProps,
  AlertSize,
  AlertVariant,
} from './src/components/Alert'
export { AudioPlayer } from './src/components/AudioPlayer'
export type { AudioPlayerProps } from './src/components/AudioPlayer'
export { TraceLogEvent } from './src/components/TraceLogEvent'
export type {
  TraceLogEventProps,
  TraceLogEventVariant,
} from './src/components/TraceLogEvent'
export { ReasoningTrailCard } from './src/components/ReasoningTrail'
export type {
  ReasoningTrailCardProps,
  ReasoningTrailStep,
  ReasoningTrailOutcome,
  ReasoningTrailResult,
  ReasoningTrailMetadata,
  ReasoningTrailMetadataRow,
} from './src/components/ReasoningTrail'
export { Feedback } from './src/components/Feedback'
export type { FeedbackProps } from './src/components/Feedback'
export {
  QuestionCard,
  questionCardHelperTextStyles,
} from './src/components/Card'
export type {
  QuestionCardProps,
  QuestionCardAnswerOption,
} from './src/components/Card'
export {
  IncidentCard,
  IncidentCardDescriptionChip,
  IncidentCardDescriptionText,
} from './src/components/Card'
export type {
  IncidentCardProps,
  IncidentCardDescriptionChipProps,
  IncidentCardDescriptionTextProps,
  IncidentCardPriority,
  IncidentCardStatus,
} from './src/components/Card'
export { ActiveIncidentCard } from './src/components/Card'
export type { ActiveIncidentCardProps } from './src/components/Card'
export { SteppedList, SteppedListSection } from './src/components/SteppedList'
export type {
  SteppedListProps,
  SteppedListSectionProps,
  SteppedListMetadata,
} from './src/components/SteppedList'
export { MultiPartForm, FormSection } from './src/components/MultiPartForm'
export type {
  MultiPartFormProps,
  FormSectionProps,
  FormSectionDef,
} from './src/components/MultiPartForm'
export { SegmentedControl } from './src/components/SegmentedControl'
export type {
  SegmentedControlOption,
  SegmentedControlOptionState,
  SegmentedControlProps,
  SegmentedControlVariant,
} from './src/components/SegmentedControl'

export { Chip } from './src/components/Chip'
export type { ChipProps, ChipVariant } from './src/components/Chip'
export { InfoBox } from './src/components/InfoBox'
export type { InfoBoxProps } from './src/components/InfoBox'
export { Tooltip } from './src/components/Tooltip/Tooltip'
export type {
  TooltipProps,
  TooltipPlacement,
} from './src/components/Tooltip/Tooltip'
export {
  SideNavContainer,
  SideNavItem,
  SIDE_NAV_WIDTH_CLOSED,
  SIDE_NAV_WIDTH_OPEN,
} from './src/components/SideNav'
export type {
  SideNavContainerProps,
  SideNavItemProps,
} from './src/components/SideNav'
export {
  SidePanel,
  SIDE_PANEL_WIDTHS,
  COLLAPSED_WIDTH as SIDE_PANEL_COLLAPSED_WIDTH,
} from './src/components/SidePanel'
export type { SidePanelProps, SidePanelSize } from './src/components/SidePanel'
export {
  Table,
  TableHeader,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  TableCheckbox,
  TableToolbar,
  TableMenuButton,
  SortIndicator,
  TablePagination,
  TABLE_MAX_WIDTH,
  TABLE_HEIGHT,
} from './src/components/Table'
export type {
  TableDensity,
  TableProps,
  TableHeaderProps,
  TableHeaderCellProps,
  TableBodyProps,
  TableRowProps,
  TableCellProps,
  TableCheckboxProps,
  TableToolbarProps,
  TableMenuButtonProps,
  TableMenuButtonItem,
  SortOrder,
  TablePaginationProps,
} from './src/components/Table'

export { Select } from './src/components/Select'
export type {
  SelectIProps,
  SelectOption,
  SelectPrimaryAction,
} from './src/components/Select'
export { WorkflowStep } from './src/components/WorkflowStep'
export type { WorkflowStepIProps } from './src/components/WorkflowStep'
export { ListSelector } from './src/components/ListSelector'
export type {
  ListSelectorProps,
  ListSelectorItem,
} from './src/components/ListSelector'
// Chakra V3 layout primitives — use these instead of @chakra-ui/react in DarkProvider contexts.
//
// The web-app is pinned to Chakra v1 while this package is on v3, so a
// consumer importing a primitive from '@chakra-ui/react' inside a
// DarkProvider subtree silently gets the v1 component (v1 theme fonts and
// palette, a separate portal/z-index scale, and no access to the semantic
// tokens below). Re-exporting them here gives those consumers a v3 import
// path that needs no wrapper.
//
// Note the v3 prop names differ from v1 for some of these: Skeleton takes
// `loading`, the boolean INVERSE of v1's `isLoaded` — migrate call sites as
// `loading={!isLoaded}`, and Text takes `truncate` / `lineClamp` (not
// `isTruncated` / `noOfLines`).
//
// Spinner is deliberately NOT re-exported from Chakra here: the v3 Spinner
// animates via the system's global keyframe layer, which is not injected on a
// Chakra-v1-hosted page, so it renders static there. Use the dark Spinner
// exported below instead.
export {
  Box,
  // v3 chakra factory — use `chakra.a`, `chakra.ul`, etc. for semantic
  // elements (with their DOM props, e.g. `href`) that resolve dark tokens.
  chakra,
  // v3 compound replacement for v1's <Collapse in>: Collapsible.Root open +
  // Collapsible.Content
  Collapsible,
  Flex,
  Grid,
  GridItem,
  HStack,
  Icon,
  Image,
  Skeleton,
  Spacer,
  Stack,
  Text,
  VStack,
  // v3 API: useClipboard({ value }) returns { copied, copy } — not v1's
  // (value) => { hasCopied, onCopy }
  useClipboard,
  useDisclosure,
} from '@chakra-ui/react'
export { Spinner } from './src/components/Spinner'
export type { SpinnerProps, SpinnerSize } from './src/components/Spinner'
export type {
  BoxProps,
  FlexProps,
  GridItemProps,
  GridProps,
  HTMLChakraProps,
  IconProps,
  ImageProps,
  SkeletonProps,
  StackProps,
  SystemStyleObject,
  TextProps,
} from '@chakra-ui/react'

export { PriorityDropdown } from './src/components/PriorityDropdown'
export type {
  PriorityDropdownProps,
  PriorityOption,
} from './src/components/PriorityDropdown'

export { FeedItem } from './src/components/FeedItem'
export type { FeedItemProps } from './src/components/FeedItem'

export { Checkbox } from './src/components/Checkbox'
export type { CheckboxProps } from './src/components/Checkbox'

export { Radio, RadioGroup } from './src/components/Radio'
export type { RadioProps, RadioGroupProps } from './src/components/Radio'

export { CheckboxFilterList } from './src/components/CheckboxFilterList'
export type {
  CheckboxFilterListProps,
  CheckboxFilterOption,
} from './src/components/CheckboxFilterList'

export { DatePicker, TimePicker } from './src/components/DatePicker'
export type {
  DatePickerProps,
  TimePickerProps,
} from './src/components/DatePicker'

export { ImagePreview } from './src/components/ImagePreview'
export type { ImagePreviewProps } from './src/components/ImagePreview'
export { ButtonTag } from './src/components/ButtonTag'
export type { ButtonTagProps } from './src/components/ButtonTag'
export { MediaToggle } from './src/components/MediaToggle'
export type { MediaToggleProps } from './src/components/MediaToggle'
export { FileThumbnail } from './src/components/FileThumbnail'
export type { FileThumbnailProps } from './src/components/FileThumbnail'
export { MediaCarousel } from './src/components/MediaCarousel'
export type { MediaCarouselProps } from './src/components/MediaCarousel'
export { FileViewer } from './src/components/FileViewer'
export type {
  FileViewerFile,
  FileViewerProps,
} from './src/components/FileViewer'

export { ProgressBar } from './src/components/ProgressBar'
export type {
  ProgressBarProps,
  ProgressBarTone,
  ProgressBarVariant,
} from './src/components/ProgressBar'

export { Waveform, getWaveformColors } from './src/components/Waveform'
export type { WaveformProps } from './src/components/Waveform'

export { RecordedFormResponses } from './src/components/RecordedFormResponses'
export type {
  RecordedFormResponsesProps,
  FormResponseAnswer,
} from './src/components/RecordedFormResponses'

// Escape-key ownership. Exported so app-side overlays that aren't built on this
// package's Modal/Drawer — the incident drawer's framer-motion sub-drawers —
// can join the same stack instead of racing it. See src/hooks/escapeStack.ts.
export { useEscapeKey } from './src/hooks/useEscapeKey'
export { useAnchoredMenuPosition } from './src/hooks/useAnchoredMenuPosition'
export type {
  AnchoredMenuAlign,
  AnchoredMenuPosition,
} from './src/hooks/useAnchoredMenuPosition'
